import { forwardRef, type Ref, type SVGProps } from "react";
const IconReloadFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M6 16c0-5.523 4.477-10 10-10a9.97 9.97 0 0 1 7.141 3H21a2 2 0 1 0 0 4h6a2 2 0 0 0 1.973-1.671l1-6a2 2 0 0 0-3.946-.658l-.222 1.336A13.96 13.96 0 0 0 16 2C8.268 2 2 8.268 2 16s6.268 14 14 14c5.653 0 10.52-3.35 12.73-8.166a2 2 0 1 0-3.636-1.668A10 10 0 0 1 16 26c-5.523 0-10-4.477-10-10"
    />
  </svg>
);
const ForwardRef = forwardRef(IconReloadFilledSVG);
ForwardRef.displayName = "IconReloadFilled";
export { ForwardRef as IconReloadFilled };
